import React from 'react';
import { StyledRoundButton } from 'components/Buttons/styled-component';
import { CoreButtonProps } from 'components/Buttons/CoreButton';

export interface RoundPrimaryButtonProps extends CoreButtonProps {}

const RoundPrimaryButton: React.FC<RoundPrimaryButtonProps> = (
  props,
): JSX.Element => {
  return (
    <StyledRoundButton
      id="primary-round-button-style"
      titleclass="primary-round-button-title"
      {...props}
    />
  );
};

export default RoundPrimaryButton;
